import jwt_decode from "jwt-decode";
import { BASE_URL } from "./../../App";
import axios from "axios";
// import { ADMIN, TEAM_ADMIN, TEAM_MEMBER } from './StaticDatas'
import moment from "moment";
import dayjs from "dayjs";

export default function getCookie(name: string) {
  return (
    document.cookie.match("(^|;)\\s*" + name + "\\s*=\\s*([^;]+)")?.pop() || ""
  );
}

export const getUsername = () => {
  try {
    const token = getCookie("detection_auth");
    let user: { name: string } = jwt_decode(token);
    return user.name;
  } catch (err) {
    console.log("Error getting Token", err);
  }
};
export const countValues = [
  {
    value: "10",
    label: "10",
  },
  {
    value: "25",
    label: "25",
  },
  {
    value: "50",
    label: "50",
  },
  {
    value: "100",
    label: "100",
  },
];
export const config = {
  headers: {
    detection_auth: getCookie("detection_auth"),
  },
};

export const clearCookie = function (name) {
  document.cookie =
    name + "=;expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=.umgapps.com";
  document.cookie =
    name +
    "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=.umgapps.com";
  document.cookie =
    "detection_auth=;expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=.umgapps.com";
  document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
};

export const defaultSearchWithList = (searchTerm) => {
  return [
    {
      searchWithins: "ALL",
      searchTerm: searchTerm,
    },
  ];
};

export function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function FormatPlatforms(string) {
  let strArr = string.split(",");
  for (let i = 0; i < strArr.length; i++) {
    if (strArr[i] === "youtube") {
      strArr[i] = "YouTube";
    } else {
      strArr[i] = strArr[i].charAt(0).toUpperCase() + strArr[i].slice(1);
    }
  }
  return strArr ? strArr.join(", ") : "";
}

// export const ADMIN = '4d460fe7-b447-454c-bb0d-7f60797a74a0'
export const USER = "7ac0853c-8182-42cc-b034-9e4804144f75";

export const getApi = (params, url) => {
  return axios
    .get(BASE_URL + url, {
      params: params,
      headers: {
        detection_auth: getCookie("detection_auth"),
      },
    })
    .then((res) => {
      return res.data;
    });
};

export const isSessionExpired = (err) => {
  try {
    const ErrStatus = JSON.parse(JSON.stringify(err));
    if (ErrStatus.status === 403 || ErrStatus.status === 401) {
      alert("Your session has expired!. Please click OK to refresh the page");
      window.location.reload();
    }
  } catch {
    console.log("Error in isSessionExpired method");
  }
};
export function deepClone(obj: any): any {
  if (typeof obj !== "object" || obj === null) {
    return obj;
  }

  let clonedObj: any = Array.isArray(obj) ? [] : {};

  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      clonedObj[key] = deepClone(obj[key]);
    }
  }

  return clonedObj;
}

export function removeEmptyAttributes(obj) {
  const newObj = {};

  for (const key in obj) {
    if (obj[key] !== null && obj[key] !== undefined && obj[key] !== "") {
      newObj[key] = obj[key];
    }
  }

  return newObj;
}

// export const restrictUser = (role) => {
//   return role === ADMIN || role === TEAM_ADMIN  ? false : true
// }

export const monthCalendar = () => {
  const months: any = [];
  const currentYear = new Date().getFullYear();
  for (let month = 0; month < 12; month++) {
    const date = new Date(currentYear, month, 1);
    const monthLabel = date.toLocaleString("default", { month: "long" });

    const monthObject = {
      value: `${monthLabel}`,
      label: `${monthLabel}`,
    };

    months.push(monthObject);
  }
  return months;
};

export const getWeekNumber = (date) => {
  date = Number(date);
  if (date < 8) {
    return 1;
  } else if (date > 7 && date < 15) {
    return 2;
  } else if (date > 14 && date < 21) {
    return 3;
  } else if (date > 20 && date < 28) {
    return 4;
  } else if (date > 27) {
    return 5;
  }
};

export const weekCalendar = (currentMonth?) => {
  const today = moment();
  if (!currentMonth) {
    currentMonth = today.month();
  } else {
    currentMonth = monthCalendar().findIndex(
      (month) => month.value === currentMonth,
    );
  }
  return [
    {
      value: "1",
      label: `Week of ${currentMonth + 1}/1 - ${currentMonth + 1}/7`,
    },
    {
      value: "2",
      label: `Week of ${currentMonth + 1}/8 - ${currentMonth + 1}/14`,
    },
    {
      value: "3",
      label: `Week of ${currentMonth + 1}/15 - ${currentMonth + 1}/21`,
    },
    {
      value: "4",
      label: `Week of ${currentMonth + 1}/22 - ${currentMonth + 1}/28`,
    },
    {
      value: "5",
      label: `Week of ${currentMonth + 1}/28 - ${currentMonth + 1}/31`,
    },
  ];
};

export const calculateWeekDates = (day, month, year) => {
  day = Number(day);
  const today = moment();
  let currentMonth = today.month();
  if (month) {
    currentMonth = monthCalendar().findIndex((item) => item.value === month);
  }
  const currentYear = year ? year : today.year();

  const startOfMonth = moment([currentYear, currentMonth]);

  let startOfWeek;

  if (day === 1) {
    startOfWeek = moment(startOfMonth).startOf("week");
  }
  if (day === 2) {
    startOfWeek = moment(startOfMonth).add(1, "weeks").startOf("week");
  }
  if (day === 3) {
    startOfWeek = moment(startOfMonth).add(2, "weeks").startOf("week");
  }
  if (day === 4) {
    startOfWeek = moment(startOfMonth).add(3, "weeks").startOf("week");
  }
  if (day === 5) {
    startOfWeek = moment(startOfMonth).add(4, "weeks").startOf("week");
  }

  const endOfWeek = moment(startOfWeek).endOf("week"); // End of the week

  return {
    startDate: startOfWeek.format("YYYY-MM-DD"),
    endDate: endOfWeek.format("YYYY-MM-DD"),
  };
};

export const yearCalendar = () => {
  const currentYear = new Date().getFullYear();
  const yearsArray: any = [];

  for (let year = currentYear - 10; year <= currentYear; year++) {
    yearsArray.push({ value: year, label: year.toString() });
  }
  return yearsArray;
};

export const getMonth = (month) => {};

export const arrayToString = (val) => {
  if (Array.isArray(val)) {
    return val.join(",");
  } else {
    return val;
  }
};

export const simulateFileUpload = (
  fileSizeInBytes,
  uploadSpeedInBytesPerSecond,
  setPercentage,
) => {
  const uploadTimeInSeconds = fileSizeInBytes / uploadSpeedInBytesPerSecond;
  const interval = 100; // Update progress every 100 milliseconds
  const totalIncrements = (uploadTimeInSeconds * 1000) / interval;
  let percentage = 0;

  const updateProgress = setInterval(() => {
    percentage = Math.min(100, percentage + 100 / totalIncrements); // Increment the percentage

    setPercentage(Math.round(percentage));

    if (percentage >= 100) {
      clearInterval(updateProgress); // Stop updating progress when it reaches 100%
    }
  }, interval);
};

export const formatDatesInFilters = (filters, dateFieldFormats) => {
  Object.keys(dateFieldFormats).forEach((field) => {
    if (filters[field]) {
      filters[field] = dayjs(filters[field]).format(dateFieldFormats[field]);
    }
  });
  return filters;
};
export const formatDatesForShowInFilters = (filters, dateFieldFormats) => {
  Object.keys(dateFieldFormats).forEach((field) => {
    if (filters[field]) {
      filters[field] = dayjs(filters[field], dateFieldFormats[field]);
    }
  });
  return filters;
};

// Commmercial Projects search function s

//

export const formatSearchList = (formValues, fieldNames) => {
  return fieldNames
    .filter(
      (fieldName) =>
        Array.isArray(formValues[fieldName]) &&
        formValues[fieldName].length > 0,
    )
    .map((fieldName) => ({
      Ids: formValues[fieldName].join(","),
      searchField: capitalizeFirstLetter(fieldName),
    }));
};

// export const createDateSearchList=(formValues)=> {
//   const dateFields = Object.keys(formValues)
//     .filter((key) => key.endsWith('From') || key.endsWith('To'))
//     .reduce((acc, key) => {
//       const prefix = key.replace(/(From|To)$/, '')
//       if (!acc[prefix]) {
//         acc[prefix] = { searchField: prefix }
//       }
//       if (key.endsWith('From')) {
//         acc[prefix].From = formValues[key]
//       } else if (key.endsWith('To')) {
//         acc[prefix].To = formValues[key]
//       }
//       return acc
//     }, {})

//   return Object.values(dateFields).filter((item: any) => item.From && item.To)
// }
//   export const createDateSearchList = (formValues) => {
//   const dateFields = Object.keys(formValues)
//     .filter((key) => key.endsWith('From') || key.endsWith('To'))
//     .reduce((acc, key) => {
//       const prefix = key.replace(/(From|To)$/, '');
//       if (!acc[prefix]) {
//         acc[prefix] = { searchField: prefix };
//       }
//       if (key.endsWith('From')) {
//         acc[prefix].From = formValues[key];
//       } else if (key.endsWith('To')) {
//         acc[prefix].To = formValues[key];
//       }
//       return acc;
//     }, {});

//   return Object.values(dateFields).filter((item:any) => item.From || item.To);
// };
// export const createDateSearchList = (formValues) => {
//   const dateFields = Object.keys(formValues)
//     .filter((key) => key.endsWith('From') || key.endsWith('To'))
//     .reduce((acc, key) => {
//       const prefix = key.replace(/(From|To)$/, '');
//       if (!acc[prefix]) {
//         acc[prefix] = { searchField: prefix, From: '', To: '' };
//       }
//       if (key.endsWith('From')) {
//         acc[prefix].From = formValues[key];
//       } else if (key.endsWith('To')) {
//         acc[prefix].To = formValues[key];
//       }
//       return acc;
//     }, {});

//   return Object.values(dateFields).map((item:any) => ({
//     ...item,
//     From: item.From || '',
//     To: item.To || '',
//   }));
// };
export const createDateSearchList = (formValues) => {
  const dateFields = Object.keys(formValues)
    .filter((key) => key.endsWith("From") || key.endsWith("To"))
    .reduce((acc, key) => {
      const prefix = key.replace(/(From|To)$/, "");
      if (!acc[prefix]) {
        acc[prefix] = { searchField: prefix, From: "", To: "" };
      }
      if (key.endsWith("From")) {
        acc[prefix].From = formValues[key] || "";
      } else if (key.endsWith("To")) {
        acc[prefix].To = formValues[key] || "";
      }
      return acc;
    }, {});

  return Object.values(dateFields).filter(
    (item: any) => item.From !== "" || item.To !== "",
  );
};

export const convertSearchWithins = (searchWithinsStr, searchTerm) => {
  const searchWithinsArray = searchWithinsStr.split(",");
  const multiSearchWithinList = searchWithinsArray.map((item) => {
    const formattedItem = item.trim().toLowerCase();
    let modifiedSearchWithinItem =
      formattedItem === "updown"
        ? "UpDown"
        : formattedItem.charAt(0).toUpperCase() + formattedItem.slice(1);
    return {
      searchWithins: modifiedSearchWithinItem,
      searchTerm: searchTerm ? searchTerm : "",
    };
  });
  return multiSearchWithinList;
};
export const splitText = (str: string | undefined | null): string[] =>
  str
    ? str
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean)
    : [];

const sourceValuePattern = /\s*\((Watermark|Extracted|User Input)\)\s*$/i;

export const parseSourceValue = (value: unknown) => {
  if (typeof value !== "string") {
    return {
      value,
      sourceLabel: "",
    };
  }

  const match = value.match(sourceValuePattern);

  if (!match) {
    return {
      value,
      sourceLabel: "",
    };
  }

  return {
    value: value.replace(sourceValuePattern, "").trim(),
    sourceLabel: match[1],
  };
};

export const stripSourceValueLabel = (value: unknown) =>
  parseSourceValue(value).value;

export const getSourceValueLabel = (value: unknown) =>
  parseSourceValue(value).sourceLabel;

export const deleteCookie = (name: string) => {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
};
// auth.service.ts
const parseJwt = (token: string) => {
  try {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    return JSON.parse(window.atob(base64));
  } catch (e) {
    return null;
  }
};
export const AuthToken = {
  get: () => getCookie("detection_auth"),

  isValid: (): boolean => {
    const token = AuthToken.get();
    if (!token) return false;

    const decoded = parseJwt(token);
    return !!decoded && decoded.exp > Date.now() / 1000;
  },

  clear: () => {
    document.cookie =
      "detection_auth=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  },
};

/**
 * Formats an ISO date string into "MM-DD-YYYY HH:mm:ss" in UTC.
 * @param {string | Date} rawDate - The date string or object to format.
 * @returns {string} The formatted date, or an empty string if invalid.
 */
export function formatReleaseDate(rawDate) {
  // 1. Handle null, undefined, or empty inputs early
  if (!rawDate) {
    return "";
  }

  const dateValue = stripSourceValueLabel(rawDate);

  if (!dateValue) {
    return "";
  }

  // 2. Try parsing into a valid Date object
  const date = new Date(dateValue as string | Date);

  // 3. Check if the parsed date is actually valid (e.g., avoid "Invalid Date" errors)
  if (isNaN(date.getTime())) {
    console.warn(`[formatReleaseDate] Invalid date provided:`, rawDate);
    return "";
  }

  // 4. Configure the Intl formatter for UTC and 24-hour time
  const formatter = new Intl.DateTimeFormat("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
    timeZone: "UTC",
  });

  // 5. Destructure the formatted components
  const formattedParts = formatter.formatToParts(date);
  const parts = Object.fromEntries(
    formattedParts.map((p) => [p.type, p.value]),
  );

  // 6. Return the perfectly assembled string
  return `${parts.month}-${parts.day}-${parts.year} ${parts.hour}:${parts.minute}:${parts.second}`;
}
